import withEditarClasificacionTrabajador from "../../hoc/withTrabajadores/withEditarClasificacionTrabajador";
import EditarClasificacionTrabajador from "../../view/components/RegistroUsuarios/Clasificacion/EditarClasificacionTrababajor/EditarClasificacionTrabajador";

export default withEditarClasificacionTrabajador(EditarClasificacionTrabajador);